import { Box, Grid, Paper, styled, TextareaAutosize, Typography } from '@mui/material';
import Button from '@mui/material/Button';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import { appRoutes } from 'app/app-routes';
import FavoriteIcons from 'common/components/FavoriteIcons';
import ImageCarousel from 'common/components/ImageCarousel';
import { buildSpecItem } from 'common/components/SpecItem';
import { imageHelper } from 'common/functions/image-helper';
import { formatters } from 'common/tools/formatters';
import { TNull } from 'common/types/t-null';
import ItemContactInfo from 'features/search/ItemContactInfo';
import {
  BodyType,
  CylinderType,
  DoorType,
  DrivetrainType,
  FuelType,
  Listing,
  TransmissionType,
  useListingsContactSellerMutation,
  User,
} from 'graphql/generated';
import moment from 'moment';
import React from 'react';
import { useDispatch } from 'react-redux';
import { NavLink, useNavigate } from 'react-router-dom';
import { cacheActions } from 'redux/cache.slice';
import WsButton from 'stories/inputs/WsButton';
import WsFlexbox from 'stories/layout/WsFlexbox';

const CustomizedTextArea = styled(TextareaAutosize)`
  outline: none;
  width: 90%;
  resize: none;
  S &:focus {
    border: none;
  }
  border: none;
  &:focus-visible {
    border: none;
  }
`;

const RecentListingView = (props: { listing?: Listing }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [contactInfoVisible, contactInfoVisibleTo] = React.useState(false);

  const getCustomFeature = (value: string, label: string, other?: TNull<string>) =>
    value === 'other' ? other || '' : label;

  const onClickListing = () => {
    navigate(`${appRoutes.itemDetail}/${props.listing!.id}/Recent Listings`);
  };
  if (!props.listing) return <div></div>;

  return (
    <Card sx={{ maxWidth: 250 }}>
      <CardMedia
        component="img"
        height="188"
        image={imageHelper.getLocation(props.listing!.images[0])}
        // image="/static/images/cards/contemplative-reptile.jpg"
        alt="recent listing"
      />
      <CardContent>
        <Typography sx={{ fontSize: 12 }} gutterBottom variant="subtitle2" component="div">
          {`${props.listing.heading.replace('Used ', '')}`}
        </Typography>
        <Typography variant="body2" color="text.secondary">
          {`${props.listing.trim}`}
        </Typography>
        <Typography variant="h6">{formatters.currency.format(props.listing.price)}</Typography>
      </CardContent>
      <CardActions>
        <Button size="small" onClick={onClickListing}>
          View Listing
        </Button>
      </CardActions>
    </Card>
  );
  // return (
  //   <>
  //     <Grid container justifyContent="center">
  //       <Grid item xs={12}>
  //         {props.listing && (
  //           <Paper elevation={2} sx={{ padding: 2 }}>
  //             <Grid container>
  //               <Grid item xs={11}>
  //                 {props.listing.viewCount && (
  //                   <Typography color="error" variant="h6" mb={0.5} ml={0.5}>
  //                     {`Viewed ${props.listing.viewCount} time${props.listing.viewCount > 1 ? 's' : ''}`}
  //                   </Typography>
  //                 )}
  //                 <Typography color="primary" variant="h4">
  //                   {`${props.listing.heading} - ${props.listing.trim}`}
  //                 </Typography>
  //               </Grid>
  //               <Grid item xs={1}></Grid>
  //               <Grid item xs={8}>
  //                 <ImageCarousel images={props.listing.images} />
  //               </Grid>
  //               <Grid item xs={4} sx={{ padding: 0, paddingLeft: 3 }}>
  //                 <Grid item xs={12}>
  //                   <Typography color="primary" variant="h4" sx={{ marginBottom: 1 }}>
  //                     {formatters.currency.format(props.listing.price)}
  //                   </Typography>
  //                   <Typography variant="h6">{`${props.listing.mileage.toLocaleString('en-US')} miles`}</Typography>
  //                   <Typography variant="subtitle1">
  //                     Location: {`${props.listing.city}, ${props.listing.state} ${props.listing.zipCode}`}
  //                   </Typography>
  //                   <Grid container sx={{ marginTop: 1 }}>
  //                     {buildSpecItem('Listing Date', moment(props.listing.listingDate).format('MMM DD, YYYY'))}
  //                     {buildSpecItem('Listing Status', ListingStatusValues[props.listing.status as ListingStatus])}
  //                     {buildSpecItem('Title Status', TitleStatusValues[props.listing.titleStatus as TitleStatus])}
  //                     {buildSpecItem(
  //                       'Exterior Color',
  //                       getCustomFeature(
  //                         props.listing.colorType,
  //                         ColorTypeValues[props.listing.colorType as ColorType],
  //                         props.listing.colorTypeOther,
  //                       ),
  //                     )}
  //                     {buildSpecItem('Condition', ConditionTypeValues[props.listing.conditionType as ConditionType])}
  //                     {buildSpecItem(
  //                       'Body Style',
  //                       getCustomFeature(
  //                         props.listing.bodyType,
  //                         BodyTypeValues[props.listing.bodyType as BodyType],
  //                         props.listing.bodyTypeOther,
  //                       ),
  //                     )}
  //                     {buildSpecItem(
  //                       'Doors',
  //                       getCustomFeature(
  //                         props.listing.doorType,
  //                         DoorTypeValues[props.listing.doorType as DoorType],
  //                         props.listing.doorTypeOther,
  //                       ),
  //                     )}
  //                     {buildSpecItem(
  //                       'Cylinders',
  //                       getCustomFeature(
  //                         props.listing.cylinderType,
  //                         CylinderTypeValues[props.listing.cylinderType as CylinderType],
  //                         props.listing.cylinderTypeOther,
  //                       ),
  //                     )}
  //                     {buildSpecItem(
  //                       'Drivetrain',
  //                       getCustomFeature(
  //                         props.listing.drivetrainType,
  //                         DrivetrainTypeValues[props.listing.drivetrainType as DrivetrainType],
  //                         props.listing.drivetrainTypeOther,
  //                       ),
  //                     )}
  //                     {buildSpecItem(
  //                       'Transmission',
  //                       getCustomFeature(
  //                         props.listing.transmissionType,
  //                         TransmissionTypeValues[props.listing.transmissionType as TransmissionType],
  //                         props.listing.transmissionTypeOther,
  //                       ),
  //                     )}
  //                     {buildSpecItem(
  //                       'Fuel',
  //                       getCustomFeature(
  //                         props.listing.fuelType,
  //                         FuelTypeValues[props.listing.fuelType as FuelType],
  //                         props.listing.fuelTypeOther,
  //                       ),
  //                     )}
  //                   </Grid>
  //                   <Grid container sx={{ marginTop: 1 }}>
  //                     <Grid item xs={12}>
  //                       <Typography color="primary" variant="h6" sx={{ marginTop: 1 }}>
  //                         Additional Description
  //                       </Typography>
  //                     </Grid>
  //                     <Grid item xs={12}>
  //                       <CustomizedTextArea readOnly value={props.listing.description} />
  //                     </Grid>
  //                   </Grid>
  //                   <Grid container sx={{ marginTop: 2 }}>
  //                     <Grid item xs={12}>
  //                       <Typography color="primary" variant="h6" sx={{ marginBottom: 1 }}>
  //                         Contact Info
  //                       </Typography>
  //                     </Grid>
  //                   </Grid>
  //                 </Grid>
  //               </Grid>
  //             </Grid>
  //           </Paper>
  //         )}
  //       </Grid>
  //     </Grid>
  //   </>
  // );
};

export default RecentListingView;
